import React, {useState} from "react";
import styles from "../index.module.scss";
import HelpTipIcon from "../../../HelpTipIcon";
import classNames from "classnames";
import {Button} from "../../../../stories/components/Button/src";
import {Input} from "../../../../stories/components/Input/src";
import {Row} from "../../../../stories/components/Layout/src";
import Select from 'react-select'
import Dropdown from "rc-dropdown/es";
import Menu, {Item as MenuItem} from "rc-menu/es";
import {SvgIcon} from "../../../../stories/components/SvgIcon/src";
import {IoChevronDown} from "react-icons/io5";

const LanguageOptions = [
    {value: 'en', label: 'English'},
    {value: 'zh_cn', label: '简体中文'},
    {value: 'zh_tw', label: '繁体中文'}
]

export function LanguageSection() {

    function onMenuClick({key}) {

    }

    return (
        <div className={styles.ItemRow}>
            <div>
                <div className={styles.ItemLabel}>
                    Language
                </div>
                <div className={styles.SubLabel}>
                    Change the language used in the user interface.
                </div>
            </div>
            <Dropdown
                trigger={['click']}
                overlay={(
                    <Menu onClick={onMenuClick}>
                        {LanguageOptions.map((item, index) => (
                            <MenuItem key={index} eventKey={item.value}>
                                <div className={'label'}>{item.label}</div>
                            </MenuItem>
                        ))}
                    </Menu>
                )}
            >
                <Button colorScheme={'secondary'} variant={'outline'} size={'sm'}
                        renderSuffix={<SvgIcon icon={IoChevronDown} size={18} color={'#999'}/>}
                >
                    <div className={'pl-sm'}>English</div>
                </Button>
            </Dropdown>

        </div>
    )
}